import axios from 'axios';


const apiBase = process.env.REACT_APP_API_URL || 'https://api.mastereducation.kz/api';


const apiClient = axios.create({
  
  baseURL: apiBase,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  },
  
  timeout: 30000, 
  
});


// Attach Bearer token if present
apiClient.interceptors.request.use(request => {
  return request;
});


apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);


apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      try {
        localStorage.removeItem('auth_token');
        localStorage.removeItem('is_logged_in');
        localStorage.removeItem('student_pk');
        localStorage.removeItem('student_id');
        localStorage.removeItem('student_name');
      } catch {}
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
